'use client';

import classNames from 'classnames';
import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { IconFilter } from 'src/general/Icons/IconFilter';
import { Button } from 'src/general/components/Button/Button';
import { plpStore } from 'src/stores/plpStore';

import styles from './PlpFiltersTrigger.module.scss';

interface Props {
  className?: string;
  prependTestId?: string;
}

/**
 * Trigger for the filters modal on PLP
 */
export const PlpFiltersTrigger: FC<Props> = ({ className, prependTestId = '' }) => {
  const { setFiltersModalOpen } = plpStore(
    (state) => ({
      setFiltersModalOpen: state.setFiltersModalOpen,
    }),
    shallow,
  );
  return (
    <Button
      className={classNames(styles.root, className, 'PlpFiltersTrigger')}
      variant="secondary"
      size="small"
      onClick={() => setFiltersModalOpen(true)}
      endIcon={<IconFilter />}
      data-testid={`${prependTestId}MobileSearch-component-filterButton`}
    >
      Filters
    </Button>
  );
};
